// Polish (pl-PL)
export default {
	title: "Metody Płatności",
	tips: "Drogi użytkowniku, proszę wypełnić swoje adresy ERC20/TRC20. Proszę nie podawać szczegółów swojego konta bankowego i hasła",
	form: {
		TransactionPassword: "Hasło Transakcji",
		Address: "Adres Portfela"
	},
	label: ["Nazwa Banku", "Kod Oddziału", "Nazwa Oddziału", "Typ Depozytu", "Numer Konta", "Właściciel Konta"],
	tabs: ["Karta Bankowa", "Sieć"],
	delete: "Usuń",
	default: "Domyślny",
	create: "Utwórz",
	type: "Typ Wypłaty",
	verifying: "weryfikowanie",
	VerifyWalletAddress: "Zweryfikuj adres portfela",
	defaultAccount: "Domyślne Konto Wypłat",
	deleteMsg: "Czy na pewno chcesz usunąć?"
};
